import React, { useState, useEffect } from "react";
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from "react-router-dom";
import { TabContentWrapper } from "../orderStyled";
import * as moment from "moment";
import AlertModal from 'web/components/AlertModal';
import ConfirmationModal from "web/components/ConfirmationModal";
import { pickupOrderDeclineApi } from "redux/actions/myPickupOrders"
import TabContentAccordion from "./TabContentsAccordion";

const TabContent = (props) => {
  const dispatch = useDispatch();
  let history = useHistory()
  const { pageData } = props
  const [tempStoreDeclineId, setTempStoreDeclineId] = useState();
  const [modal, setModal] = useState(false);
  const [alertType, setAlertType] = useState('');
  const [modalContent, setModalContent] = useState('');
  const [confirmationComment, setConfirmationComment] = useState("");
  const [yesNomodal, setYesNoModal] = useState(false);
  const [yesNoModalContent, setYesNoModalContent] = useState("");

  const declinePickupOrderFunc = (data) => {
    setYesNoModalContent("Please provide a reason for declining this pickup load request.");
    setTempStoreDeclineId(data?.tenderId);
    setYesNoModal(true);
  }

  const declinePickupOrderConfirmation = async () => {
    let response;
    setYesNoModal(!yesNomodal)
    const token = localStorage.getItem('token');
    let data = {
      locationId: localStorage.getItem('locationId'),
      tenderId: tempStoreDeclineId,
      comment: confirmationComment ?? null,
      tenderStatus: 'REJECTED'
    }
    response = await dispatch(pickupOrderDeclineApi(data, token));
    if (response?.success) {
      setAlertType('pickupOrderDeclineSuccess');
      setModalContent(response?.data?.msg);
      setModal(true);
    } else {
      setModalContent(response?.data?.error?.message || response?.message || 'Something went wrong, please try again in some time.');
      setModal(true);
    }
  }

  const pickupOrderCheckoutRedirect = (data) => {
    let obj = {
      id: data?.tenderId?.toString(),
      type: 'sellerPickupOrderCheckout'
    }
    dispatch({ type: 'CHECKOUT', payload: obj });
    history.push({ pathname: '/checkout' });
  }

  return (
    <>
      <TabContentWrapper>
        {(props.pageType === 'pending' && pageData && pageData.length > 0 && pageData[0].tenderId) ? (
          <>
            <div style={{ marginBottom: '20px', padding: '0 10px' }}>
              {pageData.map(data => (
                <>               
                  <div key={data.orderRefNumber} className="pending-tab-content-web-view">
                    <p style={{ color: '#0a5587' }}>{data.locationName}</p>
                    <p>{data.poNumber}</p>
                    <p>{`(${data.city}, ${data.state})`}</p>
                    <p>{data.quantity}</p>
                    <p style={{ color: '#0a5587' }}>{moment(data.pickupDate).format('MM/DD/YYYY')}</p>
                    <p className="button-wrapper">
                      <button className="accept" onClick={() => pickupOrderCheckoutRedirect(data)}>Accept</button>
                      <button className="reject" onClick={() => declinePickupOrderFunc(data)}>Decline</button>
                    </p>
                  </div>
                  <div key={data.orderRefNumber} className="pending-tab-content-mobile-view">
                    <div className="outer-wrapper">
                      <div className="row-class">
                        <div className="elements-class">
                          <h6>Location Name</h6>
                          <p title={data.locationName}>{data.locationName}</p>
                        </div>
                        <div className="elements-class">
                          <h6>PO Number</h6>
                          <p title={data.poNumber}>{data.poNumber}</p>
                        </div>
                      </div>
                      <div className="row-class">
                        <div className="elements-class">
                          <h6>Quantity</h6>
                          <p title={data.quantity}>{data.quantity}</p>
                        </div>
                        <div className="elements-class">
                          <h6>Req. Date</h6>
                          <p>{moment(data.pickupDate).format('MM/DD/YYYY')}</p>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div className="button-wrapper">
                      <button className="accept" onClick={() => pickupOrderCheckoutRedirect(data)}>Accept</button>
                      <button className="reject" onClick={() => declinePickupOrderFunc(data)}>Decline</button>
                    </div>
                  </div>
                </>
              ))}
            </div>
          </>
        ) : (
          (pageData && pageData.length > 0 && pageData[0].orderId) && (
            <>
              <TabContentAccordion
                pageData={pageData}
                pageTabName={props.pageType}
                updateSuccesscallBack={() => props.fetchDataCallBack()} //refresh with updated records
                pickedUpsuccessCallBack={() => props.switchTabAndFetchData(2)} // 2 is for redirecting to third tab (picked up tab) in order page
                cancelOrdersuccesscallBack={() => props.switchTabAndFetchData(4)} // 4 is for redirecting to fifth tab (cancelled tab) in order page
                claimRaisedSuccessCallBack={() => props.switchTabAndFetchData(5)} // 5 is for redirecting to sixth tab (calim tab) in order page
                rescheduleOrdersuccesscallBack={() => props.fetchDataCallBack()} //refresh with updated records
                rescheduleAcceptDeclinesuccesscallBack={() => props.fetchDataCallBack()} //refresh with updated records
                claimRaiseFromPickedUpSuccessCallBack={() => props.switchTabAndFetchData(1)} // 1 is for redirecting to second tab (scheduled tab) in order page
                claimDeclineSuccessCallBack={() => props.switchTabAndFetchData(1)} // 1 is for redirecting to second tab (scheduled tab) in order page
                claimAcceptSuccessCallBack={() => props.switchTabAndFetchData(2)} // 2 is for redirecting to third tab (picked up tab) in order page
                retryPaymentSuccessCallback={() => props.switchTabAndFetchData(3)} // 3 is for redirecting to fourth tab (completed tab) in order page
              />
            </>
          )
        )}
        {pageData?.length === 0 && <p style={{ textAlign: 'center' }}>No records found</p>}
      </TabContentWrapper>
      <AlertModal
        isOpen={modal}
        toggle={() => setModal(!modal)}
        title=""
        content={modalContent}
        link={''}
        alertType={'success'}
        callBackAlert={() => {
          if (alertType === 'pickupOrderDeclineSuccess') {
            props.fetchDataCallBack(); //refresh with updated records
          }
        }}
      />
      <ConfirmationModal
        isOpen={yesNomodal}
        toggle={() => {
          setYesNoModal(!yesNomodal);
          setConfirmationComment("");
        }}
        onClickHander={(val) => {
          if (val === "no") {
          } else declinePickupOrderConfirmation()
        }}
        content={yesNoModalContent}
        confirmationComment={confirmationComment}
        setconfirmationComment={setConfirmationComment}
      />
    </>
  )
}

export default TabContent;
